import { makeDocsLink } from '@tdp/common/constants';

export const HomePageAssets = {
  hero: `/images/home/new-home-page.jpg`,
  heroDark: `/images/home/new-home-page-dark.jpg`,
  adaptiveCard: `/images/home/adaptive-card.png`,
  importApp: `/images/home/import-app.png`,
  createApp: `/images/home/create-new-app.png`,
  copilot: `/images/home/copilot-icon.png`,
  copilotStudio: `/images/home/copilot-studio.png`,
  vsCode: `/images/home/vscode-icon.png`,
  createLight: `/images/home/create-light.png`,
  createDark: `/images/home/create-dark.png`,
  importLight: `/images/home/import-light.png`,
  importDark: `/images/home/import-dark.png`,
  cardLight: `/images/home/card-light.png`,
  cardDark: `/images/home/card-dark.png`,
};

export const ToolIcons = {
  vscode: `/images/tool-icons/vs-code-icon.png`,
  m365DevDoc: `/images/tool-icons/m365-dev-doc.png`,
  sampleAppsRepository: `/images/tool-icons/sample-apps-repository.png`,
  developerBlog: `/images/tool-icons/developer-blog.png`,
  appCompliance: `/images/tool-icons/app-compliance.png`,
  m365UIKit: `/images/tool-icons/m365-ui-kit.png`,
  teams: `/images/tool-icons/teams-icon.png`,
  teamsUIKit: `/images/tool-icons/teams-ui-kit-icon.png`,
};

export const HomeLinks = {
  TeamsSampleAppDownload: `https://dev.teams.microsoft.com/microsoft-teams-app-sample.zip`,
  TeamsCertificationDocs: makeDocsLink(
    'microsoft-365-app-certification'
  ),
  TeamsACATDocs: 'https://aka.ms/acat',
  M365DevDocs:
    'https://learn.microsoft.com/en-us/microsoftteams/platform/m365-apps/overview',
  SampleAppsRepository:
    'https://github.com/OfficeDev/microsoft-teams-samples?tab=readme-ov-file#ai-samples',
  M365DeveloperBlog: 'https://devblogs.microsoft.com/microsoft365dev/',
  CopilotDeclarativeAgents: makeDocsLink(
    'microsoft-365-copilot/extensibility/overview-declarative-agent'
  ),
  CopilotCustomEngine: makeDocsLink(
    'microsoft-365-copilot/extensibility/overview-custom-engine-agent'
  ),
  CopilotStudio: 'https://copilotstudio.microsoft.com/',
  InstallVSCodeTeamsToolkit: 'https://aka.ms/install-teams-toolkit-vsc',
};

export const ToolLinks = {
  VSCodeExt:
    'https://marketplace.visualstudio.com/items?itemName=TeamsDevApp.ms-teams-vscode-extension',
  M365KitFigma: 'https://www.figma.com/community/file/1314695480773948455',
  TeamsUITemplatesDocs: makeDocsLink(
    'microsoftteams/platform/concepts/design/design-teams-app-ui-templates'
  ),
  TeamsPlatformDocs: makeDocsLink('microsoftteams/platform/'),
};
